<div class="radio-group-flex">
	<app-form-input
		class="radio-group"
		[parentForm]="parentForm"
		
		[disabled]="disabled"
		[value]="radioButtonValue"
		
		[label]="step1.getspan1"
		[type]="'radio'"
		[rule]="'required'"
		[errorMessage]="{'required' : 'ctr_9714'}"
		[radios]="[
			{
				label: step1.getspan2,
				value: urlProfilAchValue
			},
			{
				label: step1.getspan3,
				value: urlDocConsulValue
			},
			{
				label: step1.getspan4,
				value: autreValue
			}
		]"
		[name]="radioButtonCtrlName"
	>
	</app-form-input>

	<app-form-input
		[parentForm]="parentForm"
		*ngIf="getIsUrlProfilAch()"
		[disabled]="disabled"
		[value]="communication.urlProfilAch"

		[label]="step1.urlProfilAch"
		[type]="'text'"
		[rule]="'maxSize_200|pattern_28|required'"
		[errorMessage]="{'pattern' : 'ctr_1074', 'required' : 'ctr_1076'}"
		[name]="getUid() + '_SepAtt_urlProfilAch'"
	>
	</app-form-input>

	<!---->

	<app-form-input
		[parentForm]="parentForm"
		*ngIf="getIsUrlDocConsul()"
		[disabled]="disabled"
		[value]="communication.urlDocConsul"
		
		[label]="step1.urlDocConsul"
		[type]="'text'"
		[rule]="'maxSize_200|pattern_28|required'"
		[errorMessage]="{'pattern' : 'ctr_1075', 'required' : 'ctr_1077'}"
		[name]="getUid() + '_SepAtt_urlDocConsul'"
	>
	</app-form-input>

	<!---->

	<app-form-input
		[parentForm]="parentForm"
		*ngIf="getIsAutre()"
		[disabled]="disabled"
		[value]="communication.autre"
		
		[label]="step1.autre"
		[type]="'text'"
		[rule]="'maxSize_200|pattern_28|required'"
		[errorMessage]="{'pattern' : 'ctr_9712', 'required' : 'ctr_1078'}"
		[name]="getUid() + '_SepAtt_autre'"
	>
	</app-form-input>
</div>

<!---->

<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="communication.identifiantInterne"
	
	[label]="step1.identifiantInterne"
	[type]="'text'"
	[rule]="'minSize_1|maxSize_32'"
	[name]="getUid() + '_SepAtt_identifiantInterne'"
>
</app-form-input>

<!---->

<app-doc-securite
	[uid]="getUid()"
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[docSecurite]="communication.docSecurite"
></app-doc-securite>

<!---->

<app-url-securite
	[uid]="getUid()"
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[urlSecurite]="communication.urlSecurite"
></app-url-securite>

<!---->

<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="communication.nomContact"
	
	[label]="step1.nomContact"
	[type]="'text'"
	[rule]="'minSize_1|maxSize_300|required'"
	[errorMessage]="{'required' : 'ctr_1073'}"
	[name]="getUid() + '_SepAtt_nomContact'"
>
</app-form-input>

<!---->

<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="communication.adresseMailContact"
	
	[label]="step1.adresseMailContact"
	[type]="'text'"
	[rule]="'maxSize_200|pattern_1'"
	[errorMessage]="{'pattern' : 'ctr_1131'}"
	[name]="getUid() + '_SepAtt_adresseMailContact'"
>
</app-form-input>

<!---->

<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="communication.telContact"
	
	[label]="step1.telContact"
	[type]="'text'"
	[rule]="'minSize_10|maxSize_15|pattern_39'"
	[errorMessage]="{'pattern' : 'ctr_1130'}"
	[name]="getUid() + '_SepAtt_telContact'"
>
</app-form-input>
